module.exports = __webpack_public_path__ + "static/media/3_r_grib_86.15_78.15.65e882e8.png";